export const LocalFeatureFlags = {
  ai_assistant: true,
  api_payload_export: true,
  brand_logos: true,
  catalog: true,
  collection_photoshoot: true,
  collection_techpack: true,
  decorator_profile: false,
  embeddable_viewer: true,
  hide_vector_color: true,
  lifestyle_image: true,
  local_settings: true,
  logo_underbase: true,
  org_management: true,
  product_2d: true,
  size_range_techpack: true,
  textura_viewer_setup: false,
  use_stitches_decals: true,
};
